@if (!lmColumnLayoutInfo.imageInFirstColumn) {
  @for (col of columns; track trackByIndex($index, col)) {
    <div class="lm-column">
      @if (col) {
        <lm-element
          [layoutObject]="col"
          [layoutInfo]="layoutInfo"
          [lmColumnLayoutInfo]="lmColumnLayoutInfo"
          [specFields]="specFields"
          [placeHolder]="placeHolder"
          [model]="model"
          (fieldEvent)="onFieldEvent($event)"
        ></lm-element>
      }
    </div>
  }
}
